import {
    UPDATE_SELECTED_PROJECT,
    FETCH_TEMPLATE_LIST,
    UPDATE_LOCATION_LIST,
    UPDATE_ESTATE_LIST
} from '../ActionTypes'

const API_URL = process.env.API_URL

// FETCH Estate List
const requestEstateList = () => {
    return {
        type: UPDATE_ESTATE_LIST,
        payload: []
    }
}

const receiveEstateList = (array) => {
    return {
        type: UPDATE_ESTATE_LIST,
        payload: array
    }
}

export const fetchEstateList = (token) => {
    return dispatch => {
        dispatch(requestEstateList())
        return fetch(`${API_URL}/suggest/estate`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveEstateList(json.result)))
    }
}

// FETCH Location List
const requestLocationList = () => {
    return {
        type: UPDATE_LOCATION_LIST,
        payload: []
    }
}

const receiveLocationList = (array) => {
    return {
        type: UPDATE_LOCATION_LIST,
        payload: array
    }
}

export const fetchLocationList = (token) => {
    return dispatch => {
        dispatch(requestLocationList())
        return fetch(`${API_URL}/suggest/location`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveLocationList(json.result)))
    }
}

// Fetch Templatae List
const requestTemplateList = () => {
    return {
        type: FETCH_TEMPLATE_LIST,
        payload: []
    }
}

const receiveTemplateList = (array) => {
    return {
        type: FETCH_TEMPLATE_LIST,
        payload: array
    }
}

export const fetchTemplateList = (token) => {
    return dispatch => {
        dispatch(requestTemplateList())
        return fetch(`${API_URL}/template`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                dispatch(receiveTemplateList(json.result))
            })
    }
}

export const updateSelectedProject = (project) => {
    return {
        type: UPDATE_SELECTED_PROJECT,
        payload: project
    }
}



// WEBPACK FOOTER //
// ./src/TemplateListPage/TemplateListPageActions.js